import { render, staticRenderFns } from "./App.vue?vue&type=template&id=342d447e&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=342d447e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d447e",
  null
  
)

export default component.exports